<template>
  <v-navigation-drawer v-model="isOpen" temporary absolute class="app-drawer">
    <!-- 상단 -->
    <div class="logo_container">
      <router-link to="/">
        <v-list-item>
          <v-avatar>
            <img src="../assets/logo_side.png" alt="" />
          </v-avatar>
          <v-list two-line style="margin-left: 15px">
            <v-list-item-content>
              <v-list-item-title style="font-size:1.1rem; color: black;">
                SPREADY
              </v-list-item-title>
              <v-list-item-subtitle
                style="font-size:0.8rem; color: gray; font-weight: 100;"
              >
                함께 즐기고 공유하는 세상
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list>
        </v-list-item>
      </router-link>
    </div>
    <v-divider class="drawer-divider" />
    <!-- 컨텐츠 리스트 -->
    <v-list dense class="contents_container">
      <v-list-item
        style="margin:0; padding:0;"
        v-for="item in items1"
        :key="item.title"
        :to="item.route"
        link
      >
        <div class="icon_container">
          <font-awesome-icon :icon="item.icon" class="drawer-list-icon" />
        </div>
        <v-list-item-content>
          <v-list-item-title
            class="drawer-list-text"
            style="font-size: 1rem; color: black;"
          >
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider class="drawer-divider" />
    <!-- 기능 메뉴 -->
    <v-list dense class="contents_container">
      <v-list-item
        style="margin:0; padding:0;"
        v-for="item in items2"
        :key="item.title"
        :to="item.route"
        @click="item.action"
        link
      >
        <div class="icon_container">
          <font-awesome-icon :icon="item.icon" class="menu-icons" />
        </div>
        <v-list-item-content>
          <v-list-item-title
            class="drawer-list-text"
            style="font-size: 1rem; color: black;"
          >
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider class="drawer-divider" />
    <!-- copyright -->
    <div class="drawer-bottom">
      Copyright 2021. spready.net
      <br />
      All rights reserved.
    </div>
  </v-navigation-drawer>
</template>

<script>
import * as drawerStore from "../stores/drawer";

export default {
  name: "AppDrawer",
  data() {
    return {
      drawer: null,
      items1: [
        {
          title: "영화제목 초성 퀴즈",
          icon: "angle-right",
          route: "/movie-quiz"
        },
        {
          title: "취향 심리 테스트",
          icon: "angle-right",
          route: "/world-cup"
        },
        {
          title: "영어단어 퀴즈",
          icon: "angle-right",
          route: "/english1"
        },
        {
          title: "두뇌트레이닝 사칙연산",
          icon: "angle-right",
          route: "/maths"
        },
        {
          title: "1 to 50",
          icon: "angle-right",
          route: "/onetofifty"
        },
        {
          title: "다른 색깔 찾기",
          icon: "angle-right",
          route: "/find-color"
        },
        {
          title: "지뢰 찾기",
          icon: "angle-right",
          route: "/mine-sweeper"
        }
      ],
      items2: [
        { title: "Share", icon: "comment", route: "", action: this.siteshare },
        {
          title: "Ranking",
          icon: "trophy",
          route: "/ranking",
          action: this.noaction
        },
        {
          title: "Contact",
          icon: "envelope",
          route: "/contact",
          action: this.noaction
        },
        {
          title: "Page View",
          icon: "desktop",
          route: "/visitor",
          action: this.noaction
        }
      ]
    };
  },
  computed: {
    isOpen: {
      get() {
        return drawerStore.state.isOpen;
      },
      set(val) {
        drawerStore.mutations.setIsOpen(val);
      }
    }
  },
  methods: {
    async siteshare() {
      this.$KakaoSDK.Link.sendDefault({
        objectType: "feed",
        content: {
          title: "spready.net",
          description: "함께 즐기고 공유하는 세상",
          imageUrl: "https://spready.net/img/logo_share.1637f9f8.png",
          link: {
            mobileWebUrl: "https://spready.net",
            webUrl: "https://spready.net"
          }
        }
      });
    },
    noaction() {
      null;
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Gamja+Flower&display=swap");

.app-drawer {
  z-index: var(--drawer-z-index);
  font-family: "Gamja Flower", cursive;
  display: flex;
  justify-content: left;
  align-items: left;
  text-align: left;
}
.logo_container {
  margin: 10px 0;
}
.social-icons_container {
  display: flex;
}
.menu-icons {
  font-size: 1rem;
  margin-top: 5px;
  margin-left: 5px;
  color: #555555;
}
.icon_container {
  margin: 0 20px 0 0;
}
.drawer-list-icon {
  font-size: 0.5rem;
  color: #555555;
  margin-left: 8px;
  margin-right: 10px;
}
.contents_container {
  margin-left: 22px;
}
.drawer-divider {
  margin: 0 20px;
  background: #fafafa;
}
.drawer-bottom {
  padding-top: 20px;
  margin: 0 25px;
  color: #888888;
  font-size: 1rem;
}
</style>
